import React from "react";
import { RootState } from "@src/reducers/store";
import { useSelector } from "react-redux";
import { WidgetPickerModal } from "@src/components/organisms/modals/widget-picker-modal/widget-picker-modal";

export const WidgetPicker = () => {
  const showWidgetPickerModal = useSelector(
    (state: RootState) => state.yourSlice.modals.widgetPickerModal.showModal,
  );

  return <>{showWidgetPickerModal && <WidgetPickerModal />}</>;
};
